import React from "react";
import { Box, Typography, Avatar, Card, CardContent } from "@mui/material";

const TestimonialCard = ({
  name = "Zac Carmanis",
  role = "Senior Physician",
  quote = "Lorem ipsum dolor sit amet, consecteturerti adipi scing elit, sed do eiusmod tempor.",
  date = "22.03.2024",
  avatarSrc = "path/to/avatar.jpg",
}) => {
  return (
    <Card
      sx={{
        maxWidth: { xs: "100%", md: 280 },
        borderRadius: "16px",
        backgroundColor: "rgba(244, 246, 246, 1) !important",
        boxShadow: "none",
        p: { xs: "0.8rem", xl: "1rem" },
      }}
    >
      <CardContent>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <Avatar
            src={avatarSrc}
            sx={{
              width: { xs: "37px", xl: "47px" },
              height: { xs: "37px", xl: "47px" },
              mr: 1,
            }}
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                fontSize: { xs: "1rem !important", xl: "1.25rem !important" },
                color: "#2C3E50 !important",
                lineHeight: 1.2,
                fontFamily: "DM Serif Text",
              }}
            >
              {name}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: "#7F8C8D !important",
                fontSize: {
                  xs: "0.7rem !important",
                  xl: "13px !important",
                },
                fontFamily: "'Inter', sans-serif",
              }}
            >
              {role}
            </Typography>
          </Box>
        </Box>

        {/* Quote */}
        <Typography
          variant="body1"
          sx={{
            fontSize: { xs: "0.875rem !important", xl: "17px !important" },
            color: "#2C3E50 !important",
            mb: 2,
            fontWeight: 400,
            lineHeight: { xs: "20px !important", xl: "25.41px !important" },
            lineHeight: 1.5,
            fontFamily: "'Inter', sans-serif",
            textAlign: "start !important",
          }}
        >
          "{quote}"
        </Typography>

        {/* Date */}
        <Typography
          variant="body2"
          sx={{
            color: "#00A896 !important",
            fontSize: { xs: "0.7rem !important", xl: "0.875rem !important" },
            fontWeight: 400,
            fontFamily: "'Inter', sans-serif",
            textAlign: "end !important",
          }}
        >
          {date}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default TestimonialCard;
